import React, {useState} from 'react';
import {createPortal} from 'react-dom';
import {Indicador, ParrafoIndicador} from '../../ui';
import {ButtonOrder, ContenedorCuenta, DivChangePass, InputAccount, PCuenta, TextAccount, ValueAccount} from './cuenta.elements';
import {ModalUI} from '../../ui/components/ModalUI';
import {ChangePass} from './ChangePass';
import {spanishDateFormatter} from '../../ui/components/SpanishDateFormatter';
import {useSelfDetails} from '../application/useSelfDetails';
import {RemoteDataUI} from '../../common/ui/RemoteDataUI';
import {Spinner} from 'react-bootstrap';

// Email y teléfonos como enlace, para que el comercial pueda escribir o llamar al cliente con un clic
const ContactValue = ({ value, href }) => (
  <ValueAccount>
    {value ? <a href={href}>{value}</a> : <span className="text-muted">—</span>}
  </ValueAccount>
);

const telHref = (phone) => `tel:${phone.replace(/[^\d+]/g, '')}`;

function UserDetails() {
  const [showModal, setShowModal] = useState(false);
  const { userDetailsRemoteData, isComercialMode } = useSelfDetails();

  const handleOnPasswordChanged = () => {
    setTimeout(() => setShowModal(false), 5000);
  };

  return (
    <div>
      <Indicador indicador={isComercialMode ? 'Datos del cliente' : 'Mis datos de usuario'} />
      <ParrafoIndicador parrafo={isComercialMode ? 'Datos del cliente con el que estás trabajando' : 'Mantén actualizados los datos de tu cuenta'} />

      <RemoteDataUI remoteData={userDetailsRemoteData}>
        <RemoteDataUI.Pending>
          <div className="d-flex justify-content-center">
            <Spinner />
          </div>
        </RemoteDataUI.Pending>

        <RemoteDataUI.Success>
          {
            userdata => (
              <div>
                <ContenedorCuenta className="row">
                  <div className="col-xl-12">
                    <TextAccount>Información de usuario</TextAccount>
                  </div>
                  <form className="row">
                    <div className="col-sm-6">
                      <div className="col-sm-12">
                        <PCuenta>Razón social</PCuenta>
                        <InputAccount
                          type="text"
                          name="first_name"
                          id="first_name" disabled
                          defaultValue={userdata.first_name} />
                      </div>
                      <div className="col-sm-12">
                        <PCuenta>Identificación</PCuenta>
                        <InputAccount
                          type="text"
                          name="cif_niff"
                          id="cif_niff"
                          disabled
                          value={userdata.cif_nuff} />
                      </div>
                      <div className="col-sm-12">
                        <PCuenta>Teléfono</PCuenta>
                        <ContactValue value={userdata.telefono_cliente}
                                      href={userdata.telefono_cliente && telHref(userdata.telefono_cliente)} />
                      </div>

                    </div>
                    <div className="col-sm-6">
                      <div className="col-sm-12">
                        <PCuenta>Código cliente</PCuenta>
                        <InputAccount
                          type="text"
                          name="codigo_cliente"
                          id="codigo_cliente" disabled
                          defaultValue={userdata.userbc}
                        />
                      </div>
                      <div className="col-sm-12">
                        <PCuenta>Correo electrónico</PCuenta>
                        <ContactValue value={userdata.email} href={`mailto:${userdata.email}`} />
                      </div>
                      <div className="col-sm-12">
                        <PCuenta>Fecha de registro</PCuenta>
                        <InputAccount type="text" name="fecharegistro" disabled
                                      value={spanishDateFormatter(userdata.fecha_registro)} />
                      </div>
                      <div className="col-sm-12">
                        <PCuenta>Móvil</PCuenta>
                        <ContactValue value={userdata.movil_cliente}
                                      href={userdata.movil_cliente && telHref(userdata.movil_cliente)} />
                      </div>

                    </div>
                  </form>
                  {/* En modo comercial la contraseña sería la del comercial, no la del cliente */}
                  {!isComercialMode && <DivChangePass>
                    <ButtonOrder onClick={() => setShowModal(true)}>
                      cambiar contraseña
                    </ButtonOrder>
                    {showModal && createPortal(
                      <ModalUI onClose={() => setShowModal(false)}>
                        <ChangePass onPasswordChanged={handleOnPasswordChanged} />
                      </ModalUI>,
                      document.body
                    )}
                  </DivChangePass>}
                </ContenedorCuenta>
              </div>
            )
          }
        </RemoteDataUI.Success>
      </RemoteDataUI>

    </div>
  );
}

export {UserDetails};